<template>        
  <div>
    <button @click="openDialog"></button>
    <validationEmail :dialog="visible" />
  </div> 
</template>
  
  <script>
  import validationEmail from './components/form_validation_email_components.vue';
  
  export default {
    name: 'PasswordValidation',
    components: {
      validationEmail,
    },
    data() {
    return {
      visible: false,
    };
  },
  methods: {
    openDialog() {
      this.visible = true;
    },
  },
  }
  </script>
  
  <style lang="css" scoped>
  
  </style>

  